import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

function MonthlyReport() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();

    // Get user from cookies
    const user = getCookie('user');
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    // Redirect to login if no user
    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    // Fetch Monthly Report Data
    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/monthlyReport', { user });

            if (response.status === 200) {
                console.log("Fetched Monthly Report:", response.data.message); // Debugging

                const reportData = response.data.message;

                if (typeof reportData === "object" && !Array.isArray(reportData)) {
                    setRowsData([reportData]);
                } else {
                    setRowsData(reportData);
                }
            }
        } catch (err) {
            setError(err.response?.data?.message || "Error fetching data");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    // Fetch data on component mount
    useEffect(() => {
        fetchUserData();
    }, []);
    const formatValue = (value) => {
        if (value === null || value === undefined) return "N/A"; // Handle null/undefined
        if (typeof value === "object") {
            return Object.values(value)[0]; // Extract first value from the object
        }
        return value; // Return normal value
    };
    

    // Pagination Logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rowsData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(rowsData.length / rowsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Search Filter
    const filteredRows = currentRows.filter((row) =>
        Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase()))
    );

    return (
        <div className="content-wrapper">
            {/* Content Header */}
            <div className="content-header pt-1">
                <div className="mt-2">
                    <div className="fs-4 valuesDec h4">
                       MONTHLY REPORT
                    </div>
                </div>
                <hr />

                <div className="card elevation-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn" >
                        <div className="d-flex justify-content-between">
                            <div >
                                <h4 className=" pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                            </div>

                        </div>
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Month</th>
                                    <th>Bill Amount</th>
                                    <th>Collected Amount</th>
                                    <th>Balance Amount</th>
                                    <th>Expense Amount</th>
                                    <th>Material Amount</th>
                                    <th>Rent Amount</th>
                                    <th>EB Amount</th>
                                    <th>Salary Amount</th>
                                    <th>TCCL Amount</th>
                                    <th>Purchase Amount</th>
                                    <th>Incentive Amount</th>
                                    <th>Sales Amount</th>
                                    <th>Profit Amount</th>
                                    <th>Paid Customers</th>
                                    <th>Unpaid Customers</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.Pay === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                            <td>{new Date().toLocaleString('en-us', { month: 'long', year: 'numeric' })}</td>
                                            <td>{formatValue(row.totalAmount)}</td>
                                            <td>{formatValue(row.collectedAmount)}</td>
                                            <td>{formatValue(row.balanceAmount)}</td>
                                            <td>{formatValue(row.expenseAmount)}</td>
                                            <td>{formatValue(row.materialAmount)}</td>
                                            <td>{formatValue(row.rentAmount)}</td>
                                            <td>{formatValue(row.ebAmount)}</td>
                                            <td>{formatValue(row.salaryAmount)}</td>
                                            <td>{formatValue(row.topupAmount)}</td>
                                            <td>{formatValue(row.purchaseAmount)}</td>
                                            <td>{formatValue(row.incentiveAmount)}</td>
                                            <td>{formatValue(row.salesAmount)}</td>
                                            <td>{formatValue(row.profitAmount)}</td>
                                            <td>{formatValue(row.paidCustomer)}</td>
                                            <td>{formatValue(row.unpaidCustomer)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default MonthlyReport;
